(function(){
  var PER_CLICK = 2;
  var busy = false;
  var st = null;
  function container(){ return document.getElementById('ProductGridContainer'); }
  function grid(){ return document.getElementById('product-grid'); }
  function pager(c){ return c.querySelector('.pagination-wrapper') || c.querySelector('nav.pagination'); }
  function curPage(){ var m = location.search.match(/[?&]page=(\d+)/); return m ? parseInt(m[1], 10) : 1; }
  function key(){ var u = new URL(location.href); u.searchParams.delete('page'); return 'b2bLM:' + u.pathname + u.search; }
  function pageUrl(n){ var u = new URL(location.href); u.searchParams.set('page', n); return u.toString(); }
  function lastPage(p){
    var max = 1;
    p.querySelectorAll('a, span').forEach(function(el){
      var t = (el.textContent || '').trim();
      if(/^\d+$/.test(t)){ var n = parseInt(t, 10); if(n > max) max = n; }
    });
    return max;
  }
  function total(){
    var el = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
    if(!el) return null;
    var m = (el.textContent || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }
  function isBack(){
    try{ var n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; }catch(e){ return false; }
  }
  function save(){
    if(!st) return;
    try{ sessionStorage.setItem(key(), JSON.stringify({loaded: st.loaded, y: window.scrollY})); }catch(e){}
  }
  function render(box, g){
    var shown = g.children.length, t = total();
    box.querySelector('.b2b-lm__count').textContent = 'Showing ' + shown + (t && t >= shown ? ' of ' + t : '') + ' styles';
    var btn = box.querySelector('.b2b-lm__btn');
    if(st.loaded >= st.last){ btn.style.display = 'none'; }
    else { btn.style.display = ''; btn.disabled = false; btn.textContent = 'Load more styles'; }
  }
  function loadPage(n, g){
    return fetch(pageUrl(n), {credentials: 'same-origin'})
      .then(function(r){ if(!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('product-grid');
        if(!ng) throw new Error('no grid');
        Array.prototype.slice.call(ng.children).forEach(function(li){ g.appendChild(document.importNode(li, true)); });
        st.loaded = n;
      });
  }
  function loadUpTo(target, g){
    var chain = Promise.resolve();
    for(var n = st.loaded + 1; n <= target; n++){
      (function(k){ chain = chain.then(function(){ return loadPage(k, g); }); })(n);
    }
    return chain;
  }
  function init(restore){
    var c = container(), g = grid();
    if(!c || !g) return;
    if(c.querySelector('.b2b-lm')) return;
    var p = pager(c);
    if(!p) return;
    busy = false;
    st = {loaded: curPage(), last: lastPage(p)};
    if(st.loaded !== 1) return;
    p.style.display = 'none';
    var box = document.createElement('div');
    box.className = 'b2b-lm';
    box.innerHTML = '<p class="b2b-lm__count"></p><button type="button" class="b2b-lm__btn">Load more styles</button>';
    p.parentNode.insertBefore(box, p.nextSibling);
    var btn = box.querySelector('.b2b-lm__btn');
    btn.addEventListener('click', function(){
      if(busy) return;
      busy = true;
      btn.disabled = true; btn.textContent = 'Loading...';
      loadUpTo(Math.min(st.loaded + PER_CLICK, st.last), g)
        .then(function(){ busy = false; render(box, g); save(); })
        .catch(function(){ busy = false; box.style.display = 'none'; p.style.display = ''; });
    });
    render(box, g);
    if(restore){
      var saved = null;
      try{ saved = JSON.parse(sessionStorage.getItem(key()) || 'null'); }catch(e){}
      if(saved && saved.loaded > st.loaded){
        busy = true;
        btn.disabled = true; btn.textContent = 'Loading...';
        if('scrollRestoration' in history) history.scrollRestoration = 'manual';
        loadUpTo(Math.min(saved.loaded, st.last), g)
          .catch(function(){})
          .then(function(){ busy = false; render(box, g); window.scrollTo(0, saved.y || 0); });
      }
    }
  }
  function start(){
    init(isBack());
    var c = container();
    if(c){
      new MutationObserver(function(){ if(!c.querySelector('.b2b-lm')) init(false); }).observe(c, {childList: true, subtree: true});
    }
    window.addEventListener('pagehide', save);
    document.addEventListener('click', function(e){
      var a = e.target && e.target.closest ? e.target.closest('#product-grid a') : null;
      if(a) save();
    }, true);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
